import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'

import { orderByClassesGroupFilterSelection, periodFilter } from 'app/dataProviders/filter-items'
import { subscibeTo } from 'app/common/data-box-store'
import {
  PlainDatePeriodBox,
  calcPeriodFromStart,
} from 'app/common/ui-next/_filter-compilations/plain-date-period'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'

export const dateFormat = 'DD-MM-YYYY'

const getYesterdayDate = () => {
  const yesterday = moment().subtract(1, 'days').format(dateFormat)

  const defaultDateFrom = yesterday
  const currentDateTo = yesterday

  return [defaultDateFrom, currentDateTo]
}

type Props = {
  id: string
  pending: boolean
}

export const PeriodFilter = ({ id, pending }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState(false)
  const [periodType, setPeriodType] = useState<'yesterday' | 'month'>('yesterday')

  const changePeriodToYesterday = useCallback(() => {
    return getYesterdayDate()
  }, [])

  const changePeriodToMonth = useCallback(() => {
    return calcPeriodFromStart(null, null)
  }, [])

  const handleDetailsGroupFilter = useCallback((data: OrderByClassesDetailsGroup) => {
    if (data === OrderByClassesDetailsGroup.ByClasses) {
      setFilterVisibility(false)
      return
    }
    setFilterVisibility(true)
    if (data === OrderByClassesDetailsGroup.ByComplexesAndAllowances) {
      setPeriodType('month')
      return
    }
    setPeriodType('yesterday')
  }, [])

  useEffect(() => {
    const unsubsribeDetailsGroup = subscibeTo<OrderByClassesDetailsGroup>(
      orderByClassesGroupFilterSelection.id,
      handleDetailsGroupFilter,
    )
    return unsubsribeDetailsGroup
  }, [handleDetailsGroupFilter])

  return (
    filterVisibility && <PlainDatePeriodBox
      id={id}
      key={periodType}
      label="Период времени"
      loading={pending}
      dateFormat={dateFormat}
      dataBoxData={periodFilter}
      getDefaultState={periodType === 'yesterday' ? changePeriodToYesterday : changePeriodToMonth}
      periodLimit={30}
    />
  )
}
